export default __webpack_public_path__ + "static/media/lesson6.2f5dde36.svg";